import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useAuthStore = defineStore('auth', () => {
  const user = ref(null);
  const loading = ref(false);

  const isAuthenticated = computed(() => !!user.value);

  async function refreshSession() {
    try {
      await axios.get('sanctum/csrf-cookie');
    } catch {
      // silent
    }
  }

  async function fetchUser() {
    loading.value = true;
    try {
      const response = await axios.get('user');
      user.value = response.data;
    } catch {
      user.value = null;
    } finally {
      loading.value = false;
    }
  }

  async function login() {
    await refreshSession();
    const backendUrl = import.meta.env.VITE_API_URL.replace(/\/api\/?$/, '');
    window.location.href = `${backendUrl}/auth/redirect`;
  }

  async function handleCallback() {
    loading.value = true;
    try {
      await fetchUser();
    } catch {
      user.value = null;
    } finally {
      loading.value = false;
    }
  }

  async function logout() {
    try {
      await axios.post('logout');
    } catch {
      // silent
    } finally {
      user.value = null;
    }
  }

  return { user, isAuthenticated, loading, fetchUser, login, handleCallback, logout, refreshSession };
});
